module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div>\n    '+
((__t=(zoomToggleText))==null?'':__t)+
'\n</div>';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/menu-item-expanded/product-zoom-toggle/product-zoom-toggle.html
 ** module id = 893
 ** module chunks = 1 81 172
 **/